var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"color":"white","font-size":"12px","padding":"5px 10px"}},[_vm._v(" "+_vm._s(_vm.stringvalue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }